/*
 * Copyright (C) 2018 - 2023 Entgra (Pvt) Ltd, Inc - All Rights Reserved.
 *
 * Unauthorised copying/redistribution of this file, via any medium is strictly prohibited.
 *
 * Licensed under the Entgra Commercial License, Version 1.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *       https://entgra.io/licenses/entgra-commercial/1.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import React, { useContext, useEffect, useState } from 'react';
import { List, Modal } from 'antd';
import ConfigContext from '../../../../../../../../components/ConfigContext';
import { useTranslation } from 'react-i18next';
import { DeviceDetailsContext } from '../../../../index';
import axios from 'axios';
import { handleApiError } from '../../../../../../../../services/utils/errorHandler';

const DeviceGroups = props => {
  const deviceDetails = useContext(DeviceDetailsContext);
  const { config } = useContext(ConfigContext);
  const { t } = useTranslation();
  const [groups, setGroups] = useState([]);

  useEffect(() => {
    getGroups();
  }, []);

  const getGroups = () => {
    const extraParams = {
      deviceId: deviceDetails.device.deviceIdentifier,
      deviceType: deviceDetails.device.type,
      requireGroupProps: true,
    };
    const encodedExtraParams = Object.keys(extraParams)
      .map(key => key + '=' + extraParams[key])
      .join('&');
    axios
      .get(
        window.location.origin +
          config.serverConfig.invoker.uri +
          config.serverConfig.invoker.deviceMgt +
          '/groups/device?' +
          encodedExtraParams,
        { headers: { 'Content-Type': 'application/json' } },
      )
      .then(result => {
        if (result.status === 200) {
          setGroups(result.data.data);
        }
      })
      .catch(error => {
        handleApiError(error, t('api_retrieveDeviceGroupDetailsError'), t);
      });
  };

  return (
    <div>
      <Modal
        title={t('label_groupsRelated')}
        open={props.isModalVisible}
        onCancel={props.hideModal}
        footer={null}
        maskClosable={false}
      >
        <List
          dataSource={groups}
          renderItem={item => <List.Item>{item.name}</List.Item>}
        />
      </Modal>
    </div>
  );
};
export default DeviceGroups;
